import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 12,
			fill: "#ffffff"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 12,
			width: 24,
			height: 12,
			fill: "#D7141A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4L12 12L0 20Z",
			fill: "#11457E"
		})
	]
});
export default SvgCs;
